{
    "name": "dark-daltonized",
    "primary": "#60a5fa",
    "secondary": "#a78bfa",
    "success": "#60a5fa",
    "error": "#f59e0b",
    "warning": "#fbbf24",
    "text": "#e5e7eb",
    "textDim": "#6b7280",
    "textMuted": "#9ca3af",
    "secondaryText": "#999999",
    "border": "#374151",
    "background": "",
    "accent": "#818cf8",
    "toolName": "#60a5fa",
    "toolSuccess": "#60a5fa",
    "toolError": "#f59e0b",
    "diffAdded": "#60a5fa",
    "diffRemoved": "#f59e0b",
    "diffContext": "#6b7280",
    "diffAddedDimmed": "#3b6698",
    "diffRemovedDimmed": "#9a6b17",
    "diffAddedWord": "#93c5fd",
    "diffRemovedWord": "#fbbf24",
    "diffAddedWordDimmed": "#5b8cc0",
    "diffRemovedWordDimmed": "#c99a1c",
    "diffAddedBackground": "#1d4ed8",
    "diffAddedBackgroundText": "#ffffff",
    "diffAddedBackgroundWord": "#bfdbfe",
    "diffRemovedBackground": "#b45309",
    "diffRemovedBackgroundText": "#ffffff",
    "diffRemovedBackgroundWord": "#fde68a",
    "spinnerColor": "#60a5fa",
    "claude": "#d77757",
    "claudeShimmer": "#eb9f7f",
    "permission": "#b1b9f9",
    "permissionShimmer": "#cfd7ff",
    "inputPrompt": "#60a5fa",
    "footerText": "#6b7280",
    "commandColor": "#818cf8",
    "planPrimary": "#f59e0b",
    "planBorder": "#92400e",
    "subtle": "#4b5563",
    "link": "#60a5fa",
    "code": "#e2b553",
    "subagent1": "#f59e0b",
    "subagent2": "#2563eb",
    "subagent3": "#60a5fa",
    "subagent4": "#a78bfa",
    "subagent5": "#9333ea",
    "subagent6": "#ea580c",
    "subagent7": "#818cf8",
    "subagent8": "#0891b2",
    "language": "#06b6d4"
}
